var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMonetizationSkillsIcon1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_\xD0\xA0\xD0\x8E\xD0\xA0\xC2\xBB\xD0\xA0\xD1\x95\xD0\xA0\xE2\x84\x96_1",
    clipPath: "url(#clip0_3_94265)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M30 0H4C1.79086 0 0 1.79086 0 4V30C0 32.2091 1.79086 34 4 34H30C32.2091 34 34 32.2091 34 30V4C34 1.79086 32.2091 0 30 0Z",
    fill: "#E8F7F5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M17.52 22.48V26.56",
    stroke: "#09363F",
    strokeWidth: 1.36,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M21.23 20.3499V26.5599",
    stroke: "#09363F",
    strokeWidth: 1.36,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M24.95 17V26.56",
    stroke: "#09363F",
    strokeWidth: 1.36,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M18.67 20.49V19.33C18.67 17.74 17.38 16.45 15.79 16.45H11.92C10.33 16.45 9.03998 17.74 9.03998 19.33V24.52",
    stroke: "#09363F",
    strokeWidth: 1.36,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M13.86 14.2399C15.7377 14.2399 17.26 12.7177 17.26 10.8399C17.26 8.96217 15.7377 7.43994 13.86 7.43994C11.9822 7.43994 10.46 8.96217 10.46 10.8399C10.46 12.7177 11.9822 14.2399 13.86 14.2399Z",
    stroke: "#09363F",
    strokeWidth: 1.36,
    strokeLinejoin: "bevel"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3_94265"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMonetizationSkillsIcon1);
export default __webpack_public_path__ + "static/media/monetizationSkills_icon1.c5187f6c7dcda177aac1190ca3a003db.svg";
export { ForwardRef as ReactComponent };